export const ActivateExperienceIntegrationsFlags = {
  EmailVerificationRequirement: 'emailVerificationRequirement',
  NonInteractiveRequirement: 'nonInteractiveRequirement',
  EnableComplianceContact: 'enable-compliance-contact',
  PrivacyPolicyAndTermsEnabled: 'privacyPolicyAndTermsEnabled',
  AceContentsOnChannelsToggle:
    'ace.contents-on-channels.perf-improvement-toggle',
  AceTenantAnalyticReports: 'ace.tenant-analytics.insights-and-reports',
  AceNewPendingInvitesApiIntegration:
    'ace.channel-invites-incident.new-pending-invites-api-integration',
  AceContentWorkflowRelevantToUser:
    'ace.notifications.notify-only-relevant-users-for-content-workflows',
  AceLookerEmbedChannelNameWithQuotes:
    'ace.looker-embed.channel-name-with-quotes',
  AceNotificationsDeduplicate: 'ace.notifications.deduplicate',
  AceMobilePrefetch: 'ace.mobile-prefetching',
  AceMobileAdminNotices: 'ace.mobile-admin-notices',
  StandardPinFixedWidth: 'ace.standard-pin.fixed-width',
  AceContentTargettingForTenantsFix:
    'ace.content-targetting-for-tenants-join-fix',
  AceUserFeedContentTargettingFix: 'ace.user-feed.content-targetting-fix',
  AceContentForCardsSignedUrlRefresh:
    'ace.content-for-cards.refresh-signed-urls',
  AceContentSignedUrlRefresh: 'ace.content.refresh-signed-urls',
  AceContentSignedUrlLongExpiry: 'ace.content.signed-url-long-expiry',
  AceSectionInteractionsUpdatedTable: 'ace.section-interactions.updated-table',
  EnhancedOnboardingChannelSearch: 'ace.enhanced-onboarding-channel-search',
  OnboardingProfileFirstAndLastName:
    'ace.enhanced-activate-onboarding.first-and-last-name-inputs-enable',
  OnboardingImprovementsAdminProfile:
    'ace.onboarding-improvements.improved-admin-profile',
  ReservableManagement: 'consumer-experience.reservable-manager',
  ReservableManagementCalendar: 'flex.reservable-manager-calendar',
  ReservableManagementCalendarV2: 'flex.reservable-manager-calendar-v2',
  QuantityAdvancedRule: 'flex.quantity-advanced-rule',
  AuthenticationAuth0: 'flex.authentication.auth0',
  VisitorManagement: 'space-invaders.visitor-management',
  VisitorManagementHostSelection: 'space-invaders.host-selection',
  VisitorManagementAllDayPass: 'space-invaders.all-day-pass',
  VisitorManagementDateRange: 'space-invaders.date-range',
  VisitorManagementCustomDates: 'space-invaders.custom-dates',
  VisitorManagementRepeat: 'space-invaders.repeat',
  VisitorManagementGeneralSettings:
    'space-invaders.visitor-configuration-general-settings',
  VisitorManagementSchedulingSettings:
    'space-invaders.visitor-configuration-scheduling-settings',
  VisitorManagementEmailTemplateLogoSetting:
    'space-invaders.visitor-email-template-logo-setting',
  VisitorManagementVisitorNotes: 'space-invaders.visitor-notes',
  VisitorManagementVisitorLogInfo:
    'space-invaders.visitor-management.visitor-info-logs',
  NewUserContentInteractionReceipt: 'space-invaders.new-uci-receipt',
  VisitorManagementEditRecurrence: 'space-invaders.edit-recurrence',
  VisitorManagementHostSubmisssionEmail: 'space-invaders.email-host-submission',
  VisitorManagementHostNotification: 'space-invaders.host-notification',
  VisitorManagementSmsNotification: 'space-invaders.visitor-sms-notification',
  VisitorManagementMultipleNotificationRecipients:
    'space-invaders.multiple-notification-recipients-enabled',
  VisitorManagementMobileMembersView:
    'space-invaders.visitor-management-mobile-members-view',
  VisitorManagementInsightsReports: 'space-invaders.insights-reports-tile',
  VisitorInviteBulkUpload: 'space-invaders.visitor-invite-bulk-upload',
  VisitorManagementAppleWalletPass:
    'space-invaders.visitor-management-apple-wallet-pass',
  HardwarePinManagement: 'space-invaders.hardware-pin-codes',
  RestrictChannelIntegrationsAccess:
    'squad-integrations-gateway.restrict-channel-integrations-access',
  DeleteChannelIntegrationAccess:
    'squad-integrations-gateway.delete-integration',
  ControlByWebConfigSetting:
    'squad-integrations-gateway.controlbyweb-config-setting',
  BrivoConfigSetting: 'squad-integrations-gateway.brivo-config-setting',
  YardiConfigSetting: 'squad-integrations-gateway.yardi-config-setting',
  YardiCommercialConfigSetting:
    'squad-integrations-gateway.yardi-commercial-config-setting',
  EntrataConfigSetting: 'squad-integrations-gateway.entrata-config-setting',
  RealPageConfigSetting: 'squad-integrations-gateway.realpage-config-setting',
  GeneaLocationUdf: 'squad-integrations-gateway.genea-location-udf-setting',
  GeneaVisitorManagement: 'squad-integrations-gateway.genea-visitor-management',
  CCureVisitorManagement: 'squad-integrations-gateway.ccure-visitor-management',
  AmagVisitorManagement: 'squad-integrations-gateway.amag-visitor-management',
  AmagVisitorManagementCustomerCode: 'activate-experience-integrations.amag-vm-customer-code',
  BraxosVisitorManagement:
    'squad-integrations-gateway.braxos-visitor-management',
  KastleAccessControlEnabled:
    'squad-integrations-gateway.kastle-access-control-enabled',
  GeneaVisitorCardFormat: 'squad-integrations-gateway.genea-vm-card-format',
  GenetecLongPollingApi: 'squad-integrations-gateway.genetec-long-polling-api',
  SipassVisitorManagement:
    'squad-integrations-gateway.sipass-visitor-management',
  MultiSelectDefaultSelectFix:
    'squad-integrations-gateway.fix-multiselect-dropdown',
  GallagherLicenseType:
    'squad-integrations-gateway.gallagher-enable-license-key',
  EnableKastleAppleWallet:
    'squad-integrations-gateway.enable-kastle-apple-wallet',
  EnableTenantMapping: 'squad-integrations-gateway.use-tenant-mapping',
  EnableSaltoSvn: 'squad-integrations-gateway.salto-svn-v2.5',
  SCIMUserSyncEnabled: 'squad-integrations-gateway.scim-user-sync-enabled',
  DeleteSessionsEnabled: 'squad-integrations-gateway.delete-sessions-enabled',
  UserAuditLogsEnabled: 'squad-integrations-gateway.enable-user-audit',
  UserAuditHistoryEnabled:
    'squad-integrations-gateway.enable-user-audit-history',
  EnableGoogleWallet: 'squad-integrations-gateway.google-wallet-enabled',
  FixProxyClickWebhook: 'squad-integrations-gateway.fix-proxyclick-webhook',
  KastleNotifyOnArrivalEnabled:
    'squad-integrations-gateway.kastle-notify-on-arrival-enabled',
  FixConfigDropdownValidation:
    'squad-integrations-gateway.fix-config-dropdown-validation',
  TenantMappingConvertToUUID:
    'squad-integrations-gateway.tenant-mapping-convert-to-uuid',
  DynamicLanguagesMultiLanguageToggle:
    'astro-cats.dynamic-languages.channel-multi-language-toggle',
  DynamicLanguagesMultiLanguageForMembersToggle:
    'astro-cats.dynamic-languages.channel-multi-language-for-members-toggle',
  MultiLanguageSupportNewWorkflowsUI:
    'tenant-engagement.multi-language-support.new-workflows-ui',
  MultiLanguageSupportUserLanguageSettings:
    'tenant-engagement.multi-language-support.new-user-language-settings-UI',
  MultiLanguageSupportUpdatedChannelSettings:
    'tenant-engagement.multi-language-support.new-channel-settings-UI',
  MultiLanguageSupportSearch: 'tenant-engagement.mls.search',
  MultiLanguageSupportLanguagePreviewSelector:
    'tenant-engagement.multi-language-support.language-preview-selector',
  ContentTags: 'tenant-engagement.content-tags',
  ContentTagFilters: 'tenant-engagement.content-tags.member-filters',
  SectionsChannelHierarchyAccess:
    'tenant-engagement.sections.channel-hierarchy-access',
  SectionUI: 'tenant-engagement.section-ui',
  LimitFontSizeScalingOnReactNative:
    'tenant-engagement.accessibility.limit-font-size-scaling',
  SectionUIMemberUpdate: 'tenant-engagement.section-ui-member-update',
  BlocksWithDeepClone: 'tenant-engagement.blocks-with-deepClone',
  PinningSectionContent: 'tenant-engagement.pinning-section-content',
  DraftContentState: 'tenant-engagement.draft-content-state',
  EnableTenantDomainWhitelisting: 'enable-tenant-domain-whitelisting',
  ContentInteractionTableUpdates:
    'tenant-engagement.content-interaction-data-table',
  UnderConstructionPageMobile:
    'tenant-engagement.onboarding.mobile.under-construction',
  UnderConstructionPageWeb:
    'tenant-engagement.onboarding.web.under-construction',
  ContentNotificationWithTemporal:
    'tenant-engagement.content-notification-with-temporal',
  UpdateUserCompany: 'tenant-engagement.onboarding.update-user-company',
  WorkplaceOnboarding: 'activate-core-experience.workplace-onboarding',
  WorkplaceOnboardingMobile:
    'activate-core-experience.workplace-onboarding-mobile',
  VerifyUserEmail: 'activate-core-experience.onboarding.verify-email',
  UserManagementCompaniesOptimisation:
    'activate-core-experience.user-management.companies-node-optimisation',
  EmailSendByTemporal: 'activate-core-experience.temporal-email-sender',
  AEIGetContentForSectionsPermissioning:
    'activate-experience-integrations.content-on-section-permissions',
  AeiGetUserEmailsByIntegrationKeyFix:
    'activate-experience-integrations.marketing.get-user-emails-by-integration-key-fix',
  PushNotificationFormattingEnable:
    'activate-core-experience-push-notification-formatting-enable',
  JoinUserToGroupRoleWithEventDeferral:
    'defer-channels-joined-as-workplace-member-event',
  AeiCopyTemplateClearIconColors:
    'activate-experience-integrations.copy-template.clear-icon',
  AeiCheckBlockLinkType:
    'activate-experience-integrations.content.check-block-link-type',
  UciCompanyColumn: 'activate-experience-integrations.uci-company-column',
  // Rogue flags
  AceContentsOnChannelsToggleNoPrefix: 'ace-contents-on-channels-toggle',
  AceContentOnChannelIncidentOptimizedQuery:
    'ace.content-on-channel-incident.optimized-query',
  AceContentsOnChannelsPerfImprovements:
    'ace.contents-on-channels.perf-improvements',
  AceThemeBlockThemeUseThemeFromThemeContext:
    'ace.theme.block-theme-use-theme-from-theme-context',
  AceUserManagementPolishTeamMembers: 'ace.user-management-polish.team-members',
  AceUserManagementPolishUsers: 'ace.user-management.polish-users',
  ActivateCoreExperienceGeneralAlertNew:
    'activate-core-experience.general.alert.new',
  ActivateCoreExperienceValidateEmailCaseForBulkInvite:
    'activate-core-experience.validate-email-case-for-bulk-invite',
  ActivateExperienceIntegrationsOutlookFindEventId:
    'activate-experience-integrations.outlook.find-event-id',
  ActivateInsightsMigrationsCsvTenantImport:
    'activate-insights-migrations.csv-tenant-import',
  ActivateInsightsMigrationsEnableAutoSetupButton:
    'activate-insights-migrations.enable-auto-setup-button',
  AstroCatsBuildingAccess: 'astro-cats.building-access',
  AstroCatsContentStatusPills: 'astro-cats.content-status-pills',
  AstroCatsImsUserEndpoints: 'astro-cats.ims-user-endpoints',
  AstroCatsRefactoredHasChannelRoleQuery:
    'astro-cats.refactored-has-channel-role-query',
  ConsumerExperienceOnboardingV2: 'consumer-experience-onboarding-v2',
  ConsumerExperience2FA: 'consumer-experience.2FA',
  ConsumerExperienceTM8806HideChannelTabsFromBuilding:
    'consumer-experience.TM-8806-hide-channel-tabs-from-building',
  ConsumerExperienceAppleId: 'consumer-experience.apple-id',
  ConsumerExperienceOnboardingEmailInvites:
    'consumer-experience.onboarding-email-invites',
  ConsumerExperienceOnboardingPersonalisedLogin:
    'consumer-experience.onboarding-personalised-login',
  ConsumerExperienceReservableManagerCsvExport:
    'consumer-experience.reservable-manager-csv-export',
  ConsumerExperienceReservableTimePicker:
    'consumer-experience.reservable-time-picker',
  ConsumerExperienceTimeSlots: 'consumer-experience.time-slots',
  ConsumerExperienceTimeSlotsDurations:
    'consumer-experience.time-slots-durations',
  ConsumerExperienceTimeSlotsMixpanel:
    'consumer-experience.time-slots.mixpanel',
  ConsumerExperienceTimeSlotsTodayFix:
    'consumer-experience.time-slots.today-fix',
  FlexAuthenticationAuth0LoginAlertBox:
    'flex.authentication.auth0_login_alert_box',
  FlexContentAdminNotes: 'flex.content.admin-notes',
  FlexContentUserNotes: 'flex.content.user-notes',
  FlexContinueAsGuestVisibility: 'flex.continueAsGuestVisibility',
  FlexFetchUserBeforeOnboard: 'flex.fetchUserBeforeOnboard',
  FlexQuantityWaitlist: 'flex.quantity-waitlist',
  FlexReservableWaitlist: 'flex.reservable-waitlist',
  FlexShopifyM6TeamId: 'flex.shopify-m6-team-id',
  SquadIntegrationsGatewayAlignGeneaUserResponse:
    'squad-integrations-gateway.align-genea-user-response',
  SquadIntegrationsGatewayAmagCreateCredentialV2:
    'squad-integrations-gateway.amag-create-credential-v2',
  SquadIntegrationsGatewayAwrEnableDatalakeUploadNewFilePath:
    'squad-integrations-gateway.awr-enable-datalake-upload-new-file-path',
  SquadIntegrationsGatewayAwrEnableProvision:
    'squad-integrations-gateway.awr-enable-provision',
  SquadIntegrationsGatewayAwrEnableSftp:
    'squad-integrations-gateway.awr-enable-sftp',
  SquadIntegrationsGatewayBraxosSharedPackages:
    'squad-integrations-gateway.braxos-shared-packages',
  SquadIntegrationsGatewayBraxosUserSyncDeleteDisabledCheck:
    'squad-integrations-gateway.braxos-user-sync-delete-disabled-check',
  SquadIntegrationsGatewayBrivoRemoveGetUuserApiCall:
    'squad-integrations-gateway.brivo-remove-getUuser-api-call',
  SquadIntegrationsGatewayBrivoUserAccessControlGroupCache:
    'squad-integrations-gateway.brivo-user-access-control-group-cache',
  SquadIntegrationsGatewayCcureFixDisplayProperties:
    'squad-integrations-gateway.ccure-fix-display-properties',
  SquadIntegrationsGatewayCheckCredentialState:
    'squad-integrations-gateway.check-credential-state',
  SquadIntegrationsGatewayDownloadUsersAsyncSendErrorEvent:
    'squad-integrations-gateway.download-users-async-send-error-event',
  SquadIntegrationsGatewayEnableBrivoIdp:
    'squad-integrations-gateway.enable-brivo-idp',
  SquadIntegrationsGatewayEnableBrivoV4:
    'squad-integrations-gateway.enable-brivo-v4',
  SquadIntegrationsGatewayEnableBuildingSyncIntoCes:
    'squad-integrations-gateway.enable-building-sync-into-ces',
  SquadIntegrationsGatewayEnableCcureV4:
    'squad-integrations-gateway.enable-ccure-v4',
  SquadIntegrationsGatewayEnableChargesSyncIntoAcc:
    'squad-integrations-gateway.enable-charges-sync-into-acc',
  SquadIntegrationsGatewayEnableContextMiddleware:
    'squad-integrations-gateway.enable-context-middleware',
  SquadIntegrationsGatewayEnableDatawatchV4:
    'squad-integrations-gateway.enable-datawatch-v4',
  SquadIntegrationsGatewayEnableDsxV4:
    'squad-integrations-gateway.enable-dsx-v4',
  SquadIntegrationsGatewayEnableGallagherDivisionField:
    'squad-integrations-gateway.enable-gallagher-division-field',
  SquadIntegrationsGatewayEnableGallagherIdp:
    'squad-integrations-gateway.enable-gallagher-idp',
  SquadIntegrationsGatewayEnableGeneaCardFormatsForConfig:
    'squad-integrations-gateway.enable-genea-card-formats-for-config',
  SquadIntegrationsGatewayEnableGeneaLocationUdf:
    'squad-integrations-gateway.enable-genea-location-udf',
  SquadIntegrationsGatewayEnableGeneaV4:
    'squad-integrations-gateway.enable-genea-v4',
  SquadIntegrationsGatewayEnableHostDetailsApiCall:
    'squad-integrations-gateway.enable-host-details-api-call',
  SquadIntegrationsGatewayEnableKastleEmailLogs:
    'squad-integrations-gateway.enable-kastle-email-logs',
  SquadIntegrationsGatewayEnableMaxxessV4:
    'squad-integrations-gateway.enable-maxxess-v4',
  SquadIntegrationsGatewayEnableRelaysImportWorker:
    'squad-integrations-gateway.enable-relays-import-worker',
  SquadIntegrationsGatewayEnableServiceRequestsMetadataSync:
    'squad-integrations-gateway.enable-service-requests-metadata-sync',

  SquadIntegrationsGatewayEnforceProviderTenantMappings:
    'squad-integrations-gateway.enforce-provider-tenant-mappings',
  SquadIntegrationsGatewayFetchSpacesByPagination:
    'squad-integrations-gateway.fetch-spaces-by-pagination',
  SquadIntegrationsGatewayFilterBrivoSuspendedUser:
    'squad-integrations-gateway.filter-brivo-suspended-user',
  SquadIntegrationsGatewayFilterBrivoUsersWithoutEmail:
    'squad-integrations-gateway.filter-brivo-users-without-email',
  SquadIntegrationsGatewayGallagherRestyClientTlsCertificateFix:
    'squad-integrations-gateway.gallagher-resty-client-tls-certificate-fix',
  SquadIntegrationsGatewayGenetecAssignAccessGroupFix:
    'squad-integrations-gateway.genetec-assign-access-group-fix',
  SquadIntegrationsGatewayGenetecAssignCredentialFix:
    'squad-integrations-gateway.genetec-assign-credential-fix',
  SquadIntegrationsGatewayGenetecCardholderGroupsFilterEnabled:
    'squad-integrations-gateway.genetec-cardholder-groups-filter-enabled',
  SquadIntegrationsGatewayGenetecUserSyncSkipUsers:
    'squad-integrations-gateway.genetec-user-sync-skip-users',
  SquadIntegrationsGatewayGetUserEmailsByIntegrationKeyPagination:
    'squad-integrations-gateway.get-user-emails-by-integration-key-pagination',
  SquadIntegrationsGatewayGetVisitorIntegrationInfo:
    'squad-integrations-gateway.get-visitor-integration-info',
  SquadIntegrationsGatewayGrpcErrorInterceptor:
    'squad-integrations-gateway.grpc-error-interceptor',
  SquadIntegrationsGatewayImporterJobTemporal:
    'squad-integrations-gateway.importer-job-temporal',
  SquadIntegrationsGatewayIntegrationsConfigMiddleware:
    'squad-integrations-gateway.integrations-config-middleware',
  SquadIntegrationsGatewayKastleCheckStateForCardFormatGuid:
    'squad-integrations-gateway.kastle-check-state-for-card-format-guid',
  SquadIntegrationsGatewayKastleEventStream:
    'squad-integrations-gateway.kastle-event-stream',
  SquadIntegrationsGatewayKastleVmV2: 'squad-integrations-gateway.kastle-vm-v2',
  SquadIntegrationsGatewaySipassEnableCreateCredentialMutex:
    'squad-integrations-gateway.sipass-enable-create-credential-mutex',
  SquadIntegrationsGatewaySyncCompanies:
    'squad-integrations-gateway.sync-companies',
  SquadIntegrationsGatewayUseCardFormatWiegandCsn32:
    'squad-integrations-gateway.use-card-format-wiegand-csn32',
  SquadIntegrationsGatewayUseCustomFloorsAcg:
    'squad-integrations-gateway.use-custom-floors-acg',
  SquadIntegrationsGatewayUseStreaming:
    'squad-integrations-gateway.use-streaming',
  SquadIntegrationsGatewayUseStreamingDownloadRawUsersAsync:
    'squad-integrations-gateway.use-streaming-download-raw-users-async',
  SquadIntegrationsGatewayUseStreamingDownloadUsersAsync:
    'squad-integrations-gateway.use-streaming-download-users-async',
  SquadIntegrationsGatewayVisitorPassManagement:
    'squad-integrations-gateway.visitor-pass-management',
  SquadIntegrationsGatewayVmPassManagementSleepBeforeUpdate:
    'squad-integrations-gateway.vm-pass-management-sleep-before-update',
  TenantEngagementAcsSkipEmailInvitation:
    'tenant-engagement.acs-skip-email-invitation',
  TenantEngagementMultiLanguageSupportTabNamesUnderIcon:
    'tenant-engagement.multi-language-support.tab-names-under-icon',
  TenantEngagementPrivateS3Media: 'tenant-engagement.private-s3-media',
  TenantEngagementRecurringEvents: 'tenant-engagement.recurring-events',
  TenantEngagementSectionContentPerformanceSwitchLimitSectionContent:
    'tenant-engagement.section-content-performance.switch-limit-section-content',
  TenantEngagementSectionRework: 'tenant-engagement.section-rework',
  EnableGeneaSyncAllUsers: 'enable-genea-sync-all-users',
  ActivateDataCompanyAnalytics: 'activate-data.company-analytics',
  ActivateDataWorkOrdersAnalytics: 'activate-data.work-orders-analytics',
  HardwareAccessLogs: 'hardware.access-logs',
  HardwareDeviceInfo: 'hardware.device-info',
  HardwareKioskLanguageSelector: 'hardware.kiosk-language-selector',
  HardwareKioskPrinter: 'hardware.kiosk-printer',
  HardwareKioskTroubleshootingPage: 'hardware.kiosk-troubleshooting-page',
  HardwareManagement: 'hardware.management',
  AllowChannelArchiving: 'allow-channel-archiving',
  AllowChannelSettingsRequirements: 'allow-channel-settings-requirements',
  AllowExternalAccountCreation: 'allow-external-account-creation',
  AllowMagicLinkFlag: 'allow-magic-link-flag',
  ChannelManagementFeature: 'channel-management-feature',
  EnableBulkEditCreate: 'enable-bulk-edit-create',
  EnableDynamicChannelIdentifier: 'enable-dynamic-channel-identifier',
  EnableIgsServiceRequests: 'enable-igs-service-requests',
  EnablePriceLabel: 'enable-price-label',
  EnableWebViews: 'enable-web-views',
  ExperimentLdEnvironment: 'experiment.ldEnvironment',
  NewAlertModal: 'new-alert-modal',
  RetoolTest: 'retool-test',
  SquadBbbNewAddressUi: 'squad-bbb.new-address-ui',
  SquadBbbNewDataIndicators: 'squad-bbb.new-data-indicators',
  SquadBbbNewProfileUi: 'squad-bbb.new-profile-ui',
  SquadSpaceCadetsEnablePdfDownload: 'squad-space-cadets.enable-pdf-download',
  SunnyTest: 'sunny-test',
  TestTargetingRules: 'test-targeting-rules',
  Tm3527BufferTime: 'tm-3527-buffer-time',
  UseNewAlertModalDesign: 'use-new-alert-modal-design',
  KlaroCookieConsent: 'klaro-cookie-consent',
  PrismVisitorManagementMobileKeyboardFix: 'activate-experience-integrations.building-engines-prism.mobile-keyboard-fix',
  EmailUxRefreshEnabled: 'activate-experience-integrations.email-ux-refresh-enabled',
  // Rogue flags end
} as const;
